// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '킵스바이오파마',
  targetSheetName: '수수료율',
  headerRowIndex: 10,
  headerRowCount: 1,
  dataStartRowIndex: 11,
  repeatedHeaderRowAction: 'skip',
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가(원)',
    commissionRate: '2026년 수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '제품명',
    '보험코드',
    '오리지널명',
    '성분명',
    '(구)수수료율',
    '2026년 수수료율',
    '인상',
    '약가(원)',
    '비고',
    '자사여부',
  ],
});
